export const HouseCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <g
      stroke="#693EB5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_6024_49595)"
    >
      <path d="M14.672 16.83c0-.53.43-.96.96-.96h.44c.25 0 .5-.1.68-.28l.31-.31c.37-.38.98-.38 1.36 0l.31.31c.18.18.42.28.68.28h.44c.53 0 .96.43.96.96v.44c0 .25.1.5.28.68l.31.31c.38.37.38.98 0 1.36l-.31.31c-.18.18-.28.42-.28.68v.44c0 .53-.43.96-.96.96h-.44c-.25 0-.5.1-.68.28l-.31.31c-.37.38-.98.38-1.36 0l-.31-.31a.952.952 0 00-.68-.28h-.44a.96.96 0 01-.96-.96v-.44c0-.25-.1-.5-.28-.68l-.31-.31a.954.954 0 010-1.36l.31-.31c.18-.18.28-.42.28-.68v-.44z"></path>
      <path d="M16.422 18.93l.88.88 1.75-1.75M3 21h8.68M3 7v1c0 1.66 1.34 3 3 3s3-1.34 3-3M3 7h18M3 7l2-4h14l2 4M9 8V7m0 1c0 1.66 1.34 3 3 3s3-1.34 3-3m0 0V7m0 1c0 1.66 1.34 3 3 3s3-1.34 3-3V7M5 21V10.85M19 12.95v-2.1M9 21v-4c0-1.1.9-2 2-2h1"></path>
    </g>
    <defs>
      <clipPath id="clip0_6024_49595">
        <path fill="#fff" d="M0 0H24V24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
